import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HealthBridge from "../img/HealthBridge.png";
const Work = () => {
  return (
    <div className=" m-auto justify-center align-middle">
      <div className="h-screen">
        <ul className="flex flex-col gap-5 justify-center">
          <li>
            <div className="flex justify-center flex-col m-auto">
              <h5 className="text-lg font-bold">
                Website for Health Bridge International
              </h5>
              <img
                className="w-3/4"
                src={HealthBridge}
                alt="Health Bridge"
                style={{ height: "22rem" }}
              />
            </div>
          </li>

          <li>
            <h5 className="text-lg font-bold">Innovate BLR Community</h5>
            <p>
              A community on startup events and Hackathons in BLR and across
              India! Get event schedules, speaker lineups, and networking
              opportunities.
            </p>
          </li>
        </ul>
        <p className="mt-10">PS:To join the community,please email me.</p>
      </div>
    </div>
  );
};

export default Work;
